module.exports = __webpack_public_path__ + "img/image-webp.90f69f36.png";